import api from '../../../api/clinique/_consultations'
import api_soins from '../../../api/clinique/_soin_hospitalisation'

export default {
    getReattributionAccess(data) {
        return new Promise((resolve, reject) => { api.getReattributionAccess(data).then(resolve, reject) })
    },
    getConsultationsReattribuables(data, access_token) {
        return new Promise((resolve, reject) => { api.getConsultationsReattribuables(data, access_token).then(resolve, reject) })
    },
    reattribuerConsultation(consultation_id, data, access_token) {
        return new Promise((resolve, reject) => { api.reattribuerConsultation(consultation_id, data, access_token).then(resolve, reject) })
    },
    proposerMedecin(data) { return api.proposerMedecin(data) },
    confirmerMedecin(data) { return api.confirmerMedecin(data) },
    libererMedecin(token) { return api.libererMedecin(token) },
    getMedecinsEligibles(typeId) {
        return api.getMedecinsEligibles(typeId)
    },
    getMedecinsSansAcces(typeId) { return api.getMedecinsSansAcces(typeId) },
    accorderAccesMedecin(data) { return api.accorderAccesMedecin(data) },
    getListeTypesConsultations() {
        return new Promise((resolve) => {
            api.getTypesConsultations().then((response) => {
                resolve(response);
            });
        });
    },

    getDureeValiditeConsultation(data) {
        return new Promise((resolve, reject) => {
            api.getDureeValiditeConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAllFactures() {
        return new Promise((resolve, reject) => {
            api.getAllFactures().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    // recupère soins sans consultation
    getSoinsSansConsultation() {
        return new Promise((resolve, reject) => {
            api_soins.getSoinsSansConsultation().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeConsultations(data) {
        return new Promise((resolve, reject) => {
            api.getListeConsultations(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRDV() {
        return new Promise((resolve, reject) => {
            api.getListeRDV().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListBonConsultations(data) {
        return new Promise((resolve, reject) => {
            api.getListBonConsultations(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getLatestPatientNumBonSociete(data) {
        return new Promise((resolve, reject) => {
            api.getLatestPatientNumBonSociete(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}

